import React, { useState } from 'react';
import { InputNumber, Slider, Row, Col, Tooltip} from 'antd';
import {
    CloseOutlined
} from '@ant-design/icons';


function SizeControls (props) {

    const [hookDimensions, setDimensionsHook] = useState(false);
    const minSize = 0.1;
    const maxSize = 500;

    const updateProductLength = (value) => {
        if (value >= minSize && value <= maxSize) {
            let length = value;
            let height = props.productSize.height;
            let depth = props.productSize.depth;
            if (hookDimensions) {
                let scale = length / props.productSize.length;
                height = props.productSize.height * scale;
                depth = props.productSize.depth * scale;
            }
            props.setProductSize(length, height, depth);
        }
    }

    const updateProductHeight = (value) => {
        if (value >= minSize && value <= maxSize) {
            let length = props.productSize.length;
            let height = value;
            let depth = props.productSize.depth;
            if (hookDimensions) {
                let scale = height / props.productSize.height;
                length = props.productSize.length * scale;
                depth = props.productSize.depth * scale;
            }
            props.setProductSize(length, height, depth);
        }
    }

    const updateProductDepth = (value) => {
        if (value >= minSize && value <= maxSize) {
            let length = props.productSize.length;
            let height = props.productSize.height;
            let depth = value;
            if (hookDimensions) {
                let scale = depth / props.productSize.depth;
                length = props.productSize.length * scale;
                height = props.productSize.height * scale;
            }
            props.setProductSize(length, height, depth);
        }
    }

    return (
        <>
            <div className='size-controls-container'>
                    <div className='size-controls-cross-button' onClick={()=>{props.showProductSizeControls(false)}}>
                        <CloseOutlined />
                    </div>  
                <div className='size-controls-title-container'>
                    <span className='size-controls-text'>Resize</span>
                    <Tooltip title={<span className='manrope f-12 white'>Reset to original size of the product</span>}> 
                        <div className="size-controls-text reset" onClick={()=>{props.resetProductSize()}}>
                            <div><img className='p-5 p-right' src={require("../../../../assets/images/reset-controls.svg")}/>Reset</div>
                    </div>
                    </Tooltip>
                </div>
                    
                <Row className='m-10 m-top'>
                    <Col span={22}>
                        <div  className='clipping-setting-div align-center' >
                            <span className='size-controls-text slider-text' >Width</span>
                            <Slider className='clipping-slider' onChange={(value)=>{ updateProductLength(value) }} tooltipVisible={false} trackStyle={{backgroundColor:"#276dd7"}} railStyle={{backgroundColor:"#cccccc"}} handleStyle={{backgroundColor:"#ffffff", borderColor:"#276dd7"}} step={5} min={minSize} max={maxSize} value={props.productSize.length}/>
                            <InputNumber
                            formatter={(value) => `${value}"`}
                            parser={(value) => (value.replace('"', ''))}
                            disabled={false} onChange={(value)=>{ updateProductLength(value) }} step="5" className='size-controls-number-input' value={props.productSize.length} min={minSize} max={maxSize}/>
                        </div>
                        <div className='clipping-setting-div align-center'>
                            <span className='size-controls-text slider-text'>Height</span>
                            <Slider className='clipping-slider' onChange={(value)=>{ updateProductHeight(value) }} tooltipVisible={false} trackStyle={{backgroundColor:"#276dd7"}} railStyle={{backgroundColor:"#cccccc"}} handleStyle={{backgroundColor:"#ffffff", borderColor:"#276dd7"}} step={5} min={minSize} max={maxSize} value={props.productSize.height}/>
                            <InputNumber
                            formatter={(value) => `${value}"`}
                            parser={(value) => (value.replace('"', ''))}
                            disabled={false} onChange={(value)=>{ updateProductHeight(value) }} step="5" className='size-controls-number-input' value={props.productSize.height} min={minSize} max={maxSize}/>

                        </div>
                        <div className='clipping-setting-div align-center'>
                            <span className='size-controls-text slider-text'>Depth </span>
                            <Slider className='clipping-slider' onChange={(value)=>{ updateProductDepth(value) }} tooltipVisible={false} trackStyle={{backgroundColor:"#276dd7"}} railStyle={{backgroundColor:"#cccccc"}} handleStyle={{backgroundColor:"#ffffff", borderColor:"#276dd7"}} step={5} min={minSize} max={maxSize} value={props.productSize.depth}/>
                            <InputNumber
                            formatter={(value) => `${value}"`}
                            parser={(value) => (value.replace('"', ''))}
                            disabled={false} onChange={(value)=>{ updateProductDepth(value) }} step="5" className='size-controls-number-input' value={props.productSize.depth} min={minSize} max={maxSize}/>
                        </div>
                    </Col>
                    <Col className='size-controls-pin-icon-horizontal' span={1}>
                        <div className='horizontal-divider'></div>
                        <div className='horizontal-divider'></div>
                    </Col>
                    <Col className='size-controls-pin-icon-vertical' span={1}>
                        <div className='vertical-divider'></div>
                        <Tooltip title={<span className='manrope f-12 white'>Pin to uniformly resize product in all dimensions</span>}> 
                            <img className='pin-icon p-5 p-top p-bottom' onClick={()=> { setDimensionsHook(!hookDimensions) }} src={hookDimensions ? require("../../../../assets/images/pin-controls-selected.svg"): require("../../../../assets/images/pin-controls.svg") }/>
                        </Tooltip>
                        <div className='vertical-divider'></div>
                    </Col>
                </Row>
            </div>

        </>
    )
}

export default SizeControls